module.exports = __webpack_public_path__ + "static/media/aso.e88bf26c.svg";